<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-card :title="$t('warehouse.stockouts')">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("common.filter") }} {{ $t("warehouse.stockouts") }}</h2>
            <br />
          </b-col>
          <b-col cols="3">
            <AutoComplete
              v-model="warehouse_id"
              :label="$t('warehouse.warehouse')"
              :placeholder="$t('warehouse.warehouse')"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="warehouse"
              text-title="name"
              :other-query="`filter[type]=${
                this.$route.name.includes('pharmacy') ? 'pharmacy' : 'hospital'
              }`"
            />
          </b-col>
          <b-col cols="3">
            <AutoComplete
              :label="$t('warehouse.one-item')"
              :placeholder="`${$t('common.select')} ${$t(
                'warehouse.one-item'
              )}`"
              v-model="itemId"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="item"
              text-title="name"
              :other-query="`filter[type]=${
                this.$route.name.includes('pharmacy') ? 'pharmacy' : 'hospital'
              }`"
            />
          </b-col>
          <b-col v-if="!this.$route.params.id" md="3" cols="12">
            <AutoComplete
              v-model="selectedSubcategory"
              :label="$t('warehouse.category')"
              :placeholder="$t('warehouse.category')"
              :serializer="(val) => val"
              endpoint="category-list"
              text-title="name"
              @input="assignCategoryFilter"
              :other-query="`filter[type]=${
                this.$route.name.includes('pharmacy') ? 'pharmacy' : 'hospital'
              }`"
            />
          </b-col>
          <b-col cols="3">
            <b-form-group :label="$t('common.from') + ' ' + $t('common.date')">
              <datepicker
                v-model="created_at_ge"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              ></datepicker>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group :label="$t('common.to') + ' ' + $t('common.date')">
              <datepicker
                v-model="created_at_le"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              ></datepicker>
            </b-form-group>
          </b-col>

          <b-col cols="3">
            <b-form-group
              :label="$t('common.from') + ' ' + $t('common.total_price')"
            >
              <b-form-input
                v-model="total_price_ge"
                :placeholder="$t('common.price')"
              />
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group
              :label="$t('common.to') + ' ' + $t('common.total_price')"
            >
              <b-form-input
                v-model="total_price_le"
                :placeholder="$t('common.price')"
              />
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group
              :label="$t('common.from') + ' ' + $t('common.quantity')"
            >
              <b-form-input
                v-model="quantity_ge"
                :placeholder="$t('common.quantity')"
              />
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group
              :label="$t('common.to') + ' ' + $t('common.quantity')"
            >
              <b-form-input
                v-model="quantity_le"
                :placeholder="$t('common.quantity')"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <div class="d-flex align-items-center justify-content-end mt-1">
          <b-button variant="primary" @click="getStockOutsLit()">
            {{ $t("common.search") }} 
          </b-button>
        </div>

        <!-- Search Button -->

        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("common.table") }} {{ $t("warehouse.stockouts") }}</h2>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(created_at)="data">
            <span
              style="unicode-bidi: isolate"
              :style="{
                direction: $store.state.appConfig.isRTL ? 'rtl' : 'ltr',
              }"
              >{{ data.item.created_at }}</span
            >
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- @click="printId(data.item.id)" -->
              <ActionsButtons
                :noEdit="true"
                deletePerm="delete-stockout"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                {{ $t("warehouse.one-item") }}</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getStockOutsLit()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import Datepicker from "vuejs-datepicker";
const CategoryModal = () => import("@/components/warehouse/CategoryModal.vue");
import permissionChecker from "@/mixins/permissionChecker";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
export default {
  mixins: [permissionChecker],

  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BLink,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    StatisticCardHorizontal,
    AutoComplete,
    Datepicker,
    CategoryModal,
    ActionsButtons,
    DeleteModal,
  },
  data() {
    return {
      take: 10,
      loading: true,
      itemId: "",
      categoryId: null,
      stocks: [
        {
          categoryId: "",
          quantity: "",
          batch_no: "",
          unit_price: 0,
          expiry_date: "",
          warehouse_id: "",
          item_id: this.itemId,
        },
      ],
      isNotValid: false,
      dataCount: 0,
      data: [],
      categoryFilter: "",
      EditForm: {
        quantity: "",
        batch_no: "",
        unit_price: 0,
        expiry_date: "",
        warehouse_id: "",
        item_id: this.itemId,
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        name: "",
        category_id: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        { key: "item.name", label: this.$t("common.name"), sortable: true },
        {
          key: "category.name",
          label: this.$t("warehouse.one-category"),
          sortable: true,
        },
        {
          key: "warehouse.name",
          label: this.$t("warehouse.one-warehouse"),
          sortable: true,
        },
        {
          key: "quantity",
          label: this.$t("warehouse.quantity"),
          sortable: true,
        },
        { key: "price", label: this.$t("warehouse.price"), sortable: true },
        {
          key: "total_price",
          abel: this.$t("warehouse.total-price"),
          sortable: true,
        },
        {
          key: "created_at",
          abel: this.$t("common.date"),
          sortable: true,
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
    };
  },
  mounted() {
    this.getStockOutsLit();
  },
  methods: {
    assignCategoryFilter(v) {
      this.categoryFilter = v;
    },
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.stocks = [
          {
            categoryId: "",
            quantity: "",
            batch_no: "",
            unit_price: 0,
            expiry_date: "",
            warehouse_id: "",
            item_id: this.itemId,
            _method: "POST",
          },
        ];
      } else {
        this.createMode = false;
        this.EditForm.category_id = item.category_id;
        this.EditForm.id = item.id;
        this.EditForm.quantity = item.quantity;
        this.EditForm.batch_no = item.batch_no;
        this.EditForm.expiry_date = item.expiry_date;
        this.EditForm.warehouse_id = item.warehouse_id;
        this.EditForm.unit_price = item.unit_price;
        this.EditForm.item_id = item.item_id;
        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },
    addItem() {
      this.stocks.push({
        quantity: "",
        batch_no: "",
        unit_price: 0,
        expiry_date: "",
        warehouse_id: "",
        item_id: this.itemId,
      });
    },
    removeItem(index) {
      this.stocks.splice(index, 1);
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    async getStockOutsLit() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/stockout?filter[type]=${
        this.$route.name.includes("pharmacy") ? "pharmacy" : "hospital"
      }&page=${this.page}&take=${
        this.take
      }&sort=-created_at&include=item,category,warehouse`;

      if (this.itemId) {
        url += `&filter[item_id]=${this.itemId}`;
      }
      if (this.categoryFilter) {
        url += `&filter[category_id]=${this.categoryFilter.id}`;
      }
      if (this.$route.params.id) {
        url += `&filter[invoice_id]=${this.$route.params.id}`;
      }
      if (this.created_at_ge) {
        url += `&filter[created_at-ge]=${this.created_at_ge}`;
      }
      if (this.created_at_le) {
        url += `&filter[created_at-le]=${this.created_at_le}`;
      }
      if (this.total_price_ge) {
        url += `&filter[total_price-ge]=${this.total_price_ge}`;
      }
      if (this.total_price_le) {
        url += `&filter[total_price-le]=${this.total_price_le}`;
      }
      if (this.quantity_ge) {
        url += `&filter[quantity-ge]=${this.quantity_ge}`;
      }
      if (this.quantity_le) {
        url += `&filter[quantity-le]=${this.quantity_le}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    async deleteItem() {
      await this.$store
        .dispatch("delete", `/stockout/${this.deleteForm.id}`)
        .then((response) => {
          this.getStockOutsLit();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.item.name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.item.name,
            },
          });
        });
    },
    formatExpDate(expDate) {
      // Create a new Date object from the selected date
      const date = new Date(expDate);

      // Format the date as "yyyy-MM-dd"
      const year = date.getFullYear();
      let month = "" + (date.getMonth() + 1); // getMonth() is zero-based
      let day = "" + date.getDate();

      // Pad single digit months and days with a leading zero
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      // Return the formatted date string
      return `${year}-${month}-${day}`;
    },
    submitItem() {
      // for (let item in this.errorForm) {
      //   this.errorForm[item] = '';
      //   if (this.EditForm[item] == '' || this.EditForm[item] == null)
      //     delete this.EditForm[item];
      // }

      this.stocks = this.stocks.map((stock) => ({
        ...stock,
        expiry_date: this.formatExpDate(stock.expiry_date),
      }));

      if (this.createMode) {
        (this.params.form = { stockouts: this.stocks }),
          (this.params.path = `/stockout`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Created",
                  variant: "success",
                },
              });
              this.getStockOutsLit();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = { stockouts: this.stocks }),
          (this.params.path = `/stockout/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Updated",
                  variant: "success",
                },
              });
              this.getStockOutsLit(this.itemId);
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
